"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformLocalDateToBookingDate = void 0;
const utcToZonedTimeOrDefault_1 = require("../helpers/utcToZonedTimeOrDefault");
function transformLocalDateToBookingDate(localDate, timezone) {
    const departureUTC = Date.UTC(localDate.getFullYear(), localDate.getMonth(), localDate.getDate(), localDate.getHours(), localDate.getMinutes());
    return (0, utcToZonedTimeOrDefault_1.utcToZonedTimeOrDefault)(departureUTC, timezone);
}
exports.transformLocalDateToBookingDate = transformLocalDateToBookingDate;
//# sourceMappingURL=transformLocalDateToBookingDate.js.map